import { Trans, useTranslation } from 'react-i18next';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionPricing from '../../_Sections/SectionPricing';
import SectionSizes from '../../_Sections/SectionSizes';

const PRODUCT_ID = 8;
const VIEW_PRODUCT_ID = 73;

export default function VelveteenPillowCasePage() {
  const [t] = useTranslation('page/products/velveteen-pillow-cases');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom printed Velveteen Pillowcases | Products')}
      description={t('Soft yet incredibly durable, custom printed velveteen pillow cases were designed to be used, not just looked at! Digitally printed on demand and hand-sewn in Montreal, Canada, this plush pillow case comes in 5 sizes and adds luxurious comfort to any living space!')}
    />
    
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#b4ebc9"
      bgStyle={{
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '48%',
      }}
      fullPageBg
      tag={t('The all-over print')}
      title={t('Velveteen Pillowcases')}
      text={t('Add some cozy luxury to your living space with the velveteen pillowcase, durable enough to handle the rough and tough of life without losing its regal plushiness!')}
      createUrl={productData.get('url_slug')}
      img={require('@resources/img/pages/products/velveteen-pillow/banner-1.png')}
      alt={t('Picture of a girl with a custom printed Velveteen Pillow Case')}
      details={[
        {
          img: require('@resources/img/pages/products/velveteen-pillow/icon-1.svg?url'),
          alt: t('Fabric icon'),
          text: t('80 000 double rub count 100% velveteen fabric is super durable while retaining is plush feeling'),
        },
        {
          img: require('@resources/img/pages/products/velveteen-pillow/icon-2.svg?url'),
          alt: t('Sizes icon'),
          text: t('Available in 5 sizes in both square and rectangular shapes'),
        },
        {
          img: require('@resources/img/pages/products/velveteen-pillow/icon-3.svg?url'),
          alt: t('Zipper icon'),
          text: t('Finished with invisible zipper closure in white or black'),
        },
        {
          img: require('@resources/img/pages/products/velveteen-pillow/icon-4.svg?url'),
          alt: t('Ink icon'),
          text: t('Digital, all-over prints are permanent, vibrant and printed on demand'),
        },
        {
          img: require('@resources/img/pages/products/velveteen-pillow/icon-5.svg?url'),
          alt: t('Hand-sewn icon'),
          text: t('Hand-sewn and made to order in Montreal, Canada'),
        },
      ]}
    />

    <SectionGallery images={[
      require('@resources/img/pages/products/velveteen-pillow/gallery_0.jpg'),
      require('@resources/img/pages/products/velveteen-pillow/gallery_1.jpg'),
      require('@resources/img/pages/products/velveteen-pillow/gallery_2.jpg'),
      require('@resources/img/pages/products/velveteen-pillow/gallery_3.jpg'),
      require('@resources/img/pages/products/velveteen-pillow/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your Velveteen Pillow Cases <br/> <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('With our artist-centric drop shipping services we manufacture your custom products on demand and take care of the delivery to your customers.')}
    />

    <SectionPricing
      productId={PRODUCT_ID}
      variants={['22x22','20x14','24x12','26x20']}
      optionFilters={{
        fabric: ['velveteen'],
        color: ['white', 'black', 'designed'],
      }}
      listOptions
    />

    <SectionSizes
      productId={PRODUCT_ID}
      title={t('Pillow Case Sizing')}
      text={t('Velveteen pillowcases are available in 5 diverse sizes to fit any space - 3 rectangular and 2 square.')}
    >
      <img
        src={require('@resources/img/pages/products/velveteen-pillow/measurement.svg?url')}
        style={{
          marginRight: 0,
        }}
      />
    </SectionSizes>

    <SectionBranding
      title={t('Brand your Velveteen Pillow Cases')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
      hasLabel
    />

    <SectionPairings
      text={t('Pair your velveteen pillowcase with these great products!')}
      productSlugs={['duvet-covers', 'blanket', 'tapestries']}
    />
  </div>
}
